import axios from 'axios'
import getUserLanguage from 'src/utils/getUserLanguage'

function getApiClient() {
  const apiClient = axios.create({
    baseURL: process.env.BASE_URL,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Pd-Translation-Language': getUserLanguage(),
      ...(process.env.IS_SERVER && {
        Authorization: `Token ${process.env.SERVICE_SECRET_TOKENS_SSR_SERVICE}`,
      }),
    },
  })

  if (process.env.IS_CLIENT) {
    apiClient.interceptors.request.use(config => {
      window.dispatchEvent(new CustomEvent('axios:request', { detail: config }))

      return config
    })
  }

  return apiClient
}

export default getApiClient
